<div class="site-geology">
  <ul class="nav nav-tabs not-selectable">
    @for (t of tabs; track t.key; let i = $index) {
      <li class="nav-item">
        <a class="nav-link" (click)="changerTab(i + 1)" [ngClass]="tab() === i + 1 ? 'active' : ''">
          {{ t.translateId | translate }}
        </a>
      </li>
    }
  </ul>

  <div class="geology-content">
    <div class="table-container">
      <div class="table-scroll">
        <table>
          <thead>
            <tr>
              @for (col of currentTab.columns; track col.property) {
                <th>{{ col.label | translate }}</th>
              }
              <th class="scope-col">Scope</th>
              <th class="toggle-col">{{ 'GLOBAL.ACTIF' | translate }}</th>
              <th class="action-col"></th>
            </tr>
          </thead>
          <tbody>
            @for (item of items(); track item.id; let idx = $index) {
              <tr [class.inactive]="!item.isActive" [class.modifiable]="editingIndex() === idx"
                  (click)="selectSiteItem(item, idx)">
                @for (col of currentTab.columns; track col.property) {
                  <td [title]="getItemProperty(item, col.property)">
                    @if (getScope(item) === 'site' && editingIndex() === idx && col.property !== 'id') {
                      @if (isColorColumn(col.property)) {
                        <input type="text" class="inline-edit modifiable" readonly [value]="item[col.property]"
                               [cpPosition]="'left'" [cpAlphaChannel]="'disabled'"
                               [(colorPicker)]="item[col.property]"
                               [style.background]="item[col.property]" />
                      } @else {
                        <input type="text" class="inline-edit modifiable" [(ngModel)]="item[col.property]"
                               [ngClass]="{'error-value': showErrorModif() && !item[col.property]}" />
                      }
                    } @else if (isColorColumn(col.property)) {
                      <span class="color-preview" [style.background]="item[col.property]"></span>
                      {{ item[col.property] }}
                    } @else {
                      {{ getItemProperty(item, col.property) }}
                    }
                  </td>
                }
                <td class="scope-col">
                  <span class="scope-badge" [class.scope-site]="getScope(item) === 'site'">{{ getScope(item) }}</span>
                </td>
                <td class="toggle-col" (click)="$event.stopPropagation()">
                  <label class="toggle-switch" [class.disabled]="getScope(item) === 'area'">
                    <input type="checkbox" [checked]="item.isActive"
                           [disabled]="getScope(item) === 'area'"
                           (change)="toggleItem(item)">
                    <span class="slider"></span>
                  </label>
                </td>
                <td class="action-col">
                  @if (getScope(item) === 'site' && editingIndex() === idx) {
                    <button class="btn btn-sm btn-save" (click)="updateSiteItem(item, idx); $event.stopPropagation()" [title]="'GLOBAL.MODIFIER' | translate">
                      <i class="fas fa-save"></i>
                    </button>
                  } @else if (getScope(item) === 'site') {
                    <button class="btn btn-sm btn-delete" (click)="deleteSiteItem(item); $event.stopPropagation()" [title]="'GLOBAL.SUPPRIMER' | translate">
                      <i class="fas fa-trash-alt"></i>
                    </button>
                  }
                </td>
              </tr>
            }
            @if (items().length === 0) {
              <tr>
                <td [attr.colspan]="currentTab.columns.length + 3" class="empty-row">—</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="footer" [class.focus]="isFooterFocus()">
        <div class="edit-box">
          <div class="input-label">
            <span><b>{{ 'GLOBAL.AJOUTER' | translate }}</b></span>
          </div>
          @for (col of editableColumns; track col.property) {
            <div class="input">
              @if (isColorColumn(col.property)) {
                <input type="text" readonly [value]="newItem()[col.property]"
                       [cpPosition]="'top-left'" [cpAlphaChannel]="'disabled'"
                       [(colorPicker)]="newItem()[col.property]"
                       [style.background]="newItem()[col.property]"
                       (focus)="onFooterFocus()" />
              } @else {
                <input type="text" [(ngModel)]="newItem()[col.property]"
                       (focus)="onFooterFocus()" (focusout)="onFooterBlur()"
                       [placeholder]="col.label | translate"
                       [ngClass]="{'error-value': showErrorNew() && !newItem()[col.property]}" />
              }
            </div>
          }
          <div class="icon">
            <button class="btn btn-primary" (click)="createSiteItem()">
              <i class="fas fa-save"></i>
            </button>
          </div>
          <div class="icon">
            <button class="btn btn-primary" (click)="resetNewItem()">
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
